import { getV2 } from '../utils/axios'

export const getNewSexsAPI = async () => {
  return await getV2('employee/sex')
}
